import { rememberReviewState as rememberReviewStateInAddon } from 'src/addon/reviewStateMemory';
import { parseReviewStateChangedPayload as parseReviewStateChangedPayloadInAddon } from 'src/addon/reviewLockProjection';

export const rememberReviewState = (reactionId, state) => {
  rememberReviewStateInAddon(reactionId, state);
};

export const parseReviewStateChangedPayload = (payload) =>
  parseReviewStateChangedPayloadInAddon(payload);

export const review = {
  rememberReviewState,
  parseReviewStateChangedPayload,
};
